import { render } from "./CxPoliticaPrivacidad.vue?vue&type=template&id=50849ef7&scoped=true"
import script from "./CxPoliticaPrivacidad.vue?vue&type=script&lang=js"
export * from "./CxPoliticaPrivacidad.vue?vue&type=script&lang=js"

import "./CxPoliticaPrivacidad.vue?vue&type=style&index=0&id=50849ef7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50849ef7"]])

export default __exports__